<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <!-- <imgBigCards></imgBigCards> -->
    <!-- 模块1 -->

    <!-- 内容盒子 -->
    <div class="correction-content">
      <!-- 请填写您的联系信息 -->
      <p class="a-title">请填写您的联系信息</p>

      <!-- 单选框+输入框盒子 -->
      <div class="some-input">
        <!-- 注册身份单选框 -->
        <el-form
          style="max-width: 343px"
          :model="mydata.form"
          :rules="mydata.rules"
          label-width="150px"
          class="demo-ruleForm"
          ref="formEl"
          label-position="top"
        >
          <el-form-item label="问题" prop="problem" class="my-radio">
            <el-radio-group v-model="mydata.form.problem" @change="radioChange">
              <el-radio value="1" size="large">图书纠错</el-radio>
              <el-radio value="2" size="large">图书反馈</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- （图书纠错）  -->

          <el-form-item label="图书书名" prop="name">
            <el-input
              v-model="mydata.form.name"
              placeholder="请填写您要纠错的图书"
            />
          </el-form-item>

          <el-form-item label="科目" prop="subject">
            <el-input
              v-model="mydata.form.subject"
              placeholder="请填写您要纠错的图书科目"
            />
          </el-form-item>
          <template v-if="mydata.form.problem === '1'">
            <el-form-item label="书号" prop="book_number">
              <el-input
                v-model="mydata.form.book_number"
                placeholder="请填写您要纠错的图书书号"
              />
            </el-form-item>

            <el-form-item label="页码" prop="page_number">
              <el-input
                v-model="mydata.form.page_number"
                placeholder="请填写错误码页"
              />
            </el-form-item>

            <el-form-item label="题号" prop="question_number">
              <el-input
                v-model="mydata.form.question_number"
                placeholder="请填写错误题号"
              />
            </el-form-item>

            <el-form-item label="版次" prop="year" class="edition-item">
              <el-input class="edition-input1" v-model="mydata.form.year" />
              <p class="p1">年</p>
              <el-input class="edition-input2" v-model="mydata.form.month" />
              <p class="p2">月</p>
              <p class="p3">第</p>
              <el-input class="edition-input3" v-model="mydata.form.edi" />
              <p class="p4">版</p>
              <p class="p5">第</p>
              <el-input class="edition-input3" v-model="mydata.form.order" />
              <p class="p6">次印刷</p>
            </el-form-item>
          </template>
          <el-form-item
            label="填写详细问题及建议"
            prop="recommendation"
            class="textarea-item"
          >
            <el-input
              v-model="mydata.form.recommendation"
              type="textarea"
              placeholder="不少于10字描述"
            />
          </el-form-item>

          <el-form-item label="上传照片" prop="upload_photos" class="img-item">
            <el-upload
              :action="mydata.VUE_APP_BASE_HOST + mydata.xx"
              :auto-upload="true"
              :on-success="successFile1"
              list-type="picture-card"
              :on-change="uploadChange1"
              :on-remove="uploadRemove1"
              :on-preview="uploadPreview1"
              :class="{ hiddenUpload: mydata.hiddenUpload1 }"
              accept=".jpg,.jpeg,.png,.gif"
              :file-list="mydata.fileList1"
              :show-file-list="true"
            >
              <el-icon><Plus /></el-icon>
              <p class="upload-tip">点击上传图片</p>
            </el-upload>
            <el-dialog v-model="mydata.dialogVisible5">
              <img width="100%" v-complete:src="mydata.dialogImageUrl5" />
            </el-dialog>
          </el-form-item>
          <el-form-item label="">
            <p class="text-prompt" v-if="mydata.fileList5.length === 0">
              请务必上传封面、图书在版编目数据页图片,以及建议页面图片,谢谢配合
            </p>
          </el-form-item>

          <el-form-item label="邮箱" prop="mailbox">
            <el-input
              v-model="mydata.form.mailbox"
              placeholder="针对您的反馈问题，我们将通过邮箱发送处理结果"
            />
          </el-form-item>
        </el-form>
      </div>

      <!-- 提交按钮盒子 -->
      <div class="last-box">
        <!-- 提交按钮 -->
        <el-button type="primary" @click="submitFn" :loading="mydata.btnLoading"
          >确认提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowRight } from "@element-plus/icons-vue";
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import imgBigCards from "@/components/imgBigCards/index.vue";

import { bookError, bookFeedback } from "@/api/home/index.js";

const router = useRouter();

const formEl = ref(null);

const mydata = reactive({
  xx: "/api/sale_auth/upload_file",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  // 第一个
  hiddenUpload1: false,
  dialogVisible1: false,
  dialogImageUrl1: "",
  fileList1: [],
  fiveM1: 1024 * 1024 * 5, // 单位字节B
  radio1: "1",
  size: "default",
  upload: {
    dialogImageUrl: "",
    dialogVisible: "",
    disabled: false,
  },
  form: {
    problem: "1",
    name: "",
    subject: "",
    book_number: "",
    page_number: "",
    question_number: "",

    year: "",
    month: "",
    edi: "",
    order: "",

    recommendation: "",
    upload_photos: [],

    mailbox: "",
  },
  // 上传照片
  hiddenUpload5: false,
  dialogVisible5: false,
  dialogImageUrl5: "",
  fileList5: [],
  fiveM5: 1024 * 1024 * 5, // 单位字节B

  rules: {
    problem: [
      {
        required: true,
        message: "请选择您的问题",
      },
    ],
    name: [
      {
        required: true,
        message: "请填写书名",
      },
    ],
    subject: [
      {
        required: true,
        message: "请填写科目",
      },
    ],
    book_number: [
      {
        required: true,
        message: "请填写书号",
      },
    ],

    page_number: [
      {
        required: true,
        message: "请填写页码",
      },
    ],

    question_number: [
      {
        required: true,
        message: "请填写题号",
      },
    ],

    year: [
      {
        required: true,
        message: "请填写年份",
      },
      {
        validator: validator_edition,
      },
    ],
    recommendation: [
      {
        required: true,
        message: "请填写问题描述",
      },
      { min: 10, message: "最少10个字符" },
    ],
    upload_photos: [
      {
        required: true,
        message: "请上传图片",
      },
    ],
    mailbox: [
      {
        required: true,
        message: "请填写您的邮箱",
      },
    ],
  },

  checked1: false,

  btnLoading: false,
});

// 是否为空白字符串
function isWhiteStr(str) {
  let reg = /^\s*$/;
  return reg.test(str);
}

// 自定义验证规则-版次
function validator_edition(rule, value, callback) {
  if (isWhiteStr(mydata.form.year)) {
    callback(new Error("请填写年份"));
  } else if (isWhiteStr(mydata.form.month)) {
    // console.log(2);
    callback(new Error("请填写月份"));
  } else if (isWhiteStr(mydata.form.edi)) {
    // console.log(3);
    callback(new Error("请填写版本"));
  } else if (isWhiteStr(mydata.form.order)) {
    // console.log(4);
    callback(new Error("请填写印刷次数"));
  } else {
    callback();
  }
}

// 提交事件
function submitFn() {
  // console.log(formEl.value);
  // console.log(mydata.form);

  formEl.value.validate((valid, fields) => {
    if (valid) {
      // console.log("可以了");

      // 图书纠错
      if (mydata.form.problem === "1") {
        bookError({
          book_name: mydata.form.name, // 图书名称
          subject: mydata.form.subject, // 学科
          book_number: mydata.form.book_number, // 图书编号
          page_number: mydata.form.page_number, // 页码
          question_number: mydata.form.question_number, // 题号
          edition_year: mydata.form.year, // 版次-年
          edition_month: mydata.form.month, // 版次-月
          print_batch: mydata.form.order, // 印刷批次
          edition_version: mydata.form.edi, // 版本
          descr: mydata.form.recommendation, // 问题说明
          images: mydata.form.upload_photos.join(","), // 图片文件
          email: mydata.form.mailbox, // 邮箱
        }).then((res) => {
          // 提示
          ElMessage({
            message: res.msg,
            type: "success",
          });
        });
      }
      // 图书反馈
      if (mydata.form.problem === "2") {
        bookFeedback({
          book_name: mydata.form.name, // 图书名称
          subject: mydata.form.subject, // 学科
          // book_number: mydata.form.book_number, // 图书编号
          // page_number: mydata.form.page_number, // 页码
          // question_number: mydata.form.question_number, // 题号
          // edition_year: mydata.form.year, // 版次-年
          // edition_month: mydata.form.month, // 版次-月
          // print_batch: mydata.form.order, // 印刷批次
          // edition_version: mydata.form.edi, // 版本
          descr: mydata.form.recommendation, // 问题说明
          images: mydata.form.upload_photos.join(","), // 图片文件
          email: mydata.form.mailbox, // 邮箱
        }).then((res) => {
          // 提示
          ElMessage({
            message: res.msg,
            type: "success",
          });
        });
      }
    }
  });
}

// 文件改变事件
function uploadChange1(file, fileList) {
  // 判断文件大小，如果文件过大，那么清空文件列表
  if (file.size > mydata.fiveM1) {
    // 提示
    ElMessage({
      message: "文件大小请控制在5M之内",
      type: "warning",
    });
    // 赋值
    mydata.fileList1 = [];
  } else {
    // 赋值
    mydata.fileList1 = fileList;
    // 赋值
    mydata.hiddenUpload1 = mydata.fileList1.length === 10 ? true : false;
  }
  // 打印一下
  // console.log("我的数据", mydata.fileList1);
}

// 文件移除事件
function uploadRemove1(file, fileList) {
  // 赋值
  mydata.fileList1 = fileList;
  // 赋值
  mydata.hiddenUpload1 = mydata.fileList1.length === 10 ? true : false;
  // 赋值
  mydata.form.upload_photos = fileList.map((item) => {
    return item.response.data.url;
  });
}

// 文件预览事件
function uploadPreview1(file, fileList) {
  // 显示弹窗
  mydata.dialogVisible1 = true;
  // 赋值地址
  mydata.dialogImageUrl1 = file.url;
}

// 出版物许可证-文件上传成功
function successFile1(val) {
  mydata.form.upload_photos.push(val.data.url);
  // console.log(mydata.form);
}

// 单选框改变事件
function radioChange() {
  // console.log(mydata.form.problem);
}
</script>

<style scoped lang="scss">
.books-details {
  // background-color: #f9f9f9;
  // overflow: hidden;
  // border: 1px solid red;
  // padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //内容盒子
  .correction-content {
    // width: 1200px;
    // height: 900px;
    margin: 0 auto;
    padding: 16px 16px 40px 16px;
    background-color: #ffffff;
    // box-shadow: 0px 5px 40px 0px #0000000d;
    // border-radius: 8px;
    /////  标题  (请填写您的联系信息)
    .a-title {
      border-left: 4px solid #009de0;
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      padding-left: 10px;
      margin-bottom: 20px;
    }

    ////// 单选框 + 输入框 盒子 ////////////////////////////////////
    .some-input {
      // width: 750px;
      // height: 822px;
      // border: 1px solid blue;
      margin: 0 auto;
      // margin-top: 20px;
      // margin-bottom: 20px;
      overflow: hidden;

      //选择问题
      // :deep(.el-form-item.is-required.asterisk-left.id-box) {
      //   border: 1px solid red;
      //   margin-bottom: 10px;
      //   // margin-left: 98px;
      //   height: 32px;
      //   .el-form-item__content {
      //     margin-top: -5px;
      //     border: 1px solid red;
      //     .el-radio.el-radio--large {
      //       font-size: 14px;
      //       font-weight: 400;
      //       color: #333333;
      //       .el-radio__inner {
      //         width: 20px;
      //         height: 20px;
      //         // border-color:#666666;
      //       }
      //     }
      //   }
      // }

      //密码框后的小眼睛
      :deep(.el-icon.el-input__icon.el-input__password) {
        font-size: 20px;
        // color:blue;
      }

      //下拉框、输入框 、textarea框 的长度（包括字体）
      :deep(.el-form-item.is-required.asterisk-left) {
        width: 343px;
        margin-bottom: 16px;
        // height:32px;
        // border:1px solid blue;
        //字体
        .el-form-item__label {
          color: #000000;
          font-size: 14px;
          font-weight: 400;
          display: block;
        }

        //输入框
        .el-input {
          height: 40px;
        }
      }

      //选择问题
      // :deep(.el-form-item.is-required.asterisk-left.my-radio){
      //   border:1px solid red;
      // }

      // // 版次的整体长度
      // :deep(.el-form-item.is-required.asterisk-left.edition-item) {
      //   border: 1px solid red;
      //   width: 670px !important;
      // }
      //版次输入框
      :deep(.el-input.edition-input1) {
        width: 55px;
      }
      //版次输入框
      :deep(.el-input.edition-input2) {
        width: 40px;
      }
      //版次输入框
      :deep(.el-input.edition-input3) {
        width: 50px;
      }

      .p1 {
        margin-left: 2px;
        margin-right: 5px;
      }
      .p2 {
        margin-left: 2px;
        margin-right: 8px;
      }
      .p3 {
        margin-right: 2px;
      }
      .p4 {
        margin-left: 2px;
        margin-right: 8px;
      }
      .p5 {
        margin-right: 2px;
      }
      .p6 {
        margin-left: 2px;
      }

      //textarea框的长度（包括字体）
      :deep(.el-form-item.is-required.asterisk-left.textarea-item) {
        // border: 1px solid blue;
        width: 343px;
      }

      //textarea框
      :deep(.el-textarea__inner) {
        min-height: 158px !important;
        // border:1px solid red;
      }

      ////////////////////////////////////////////
      /// 上传照片文字
      :deep(.el-form-item.asterisk-left) {
        .el-form-item__content {
          margin-left: 0px !important;

          .text-prompt {
            width: 343px !important;
            line-height: 22px;
            font-size: 14px;
            font-weight: 400;
            color: #bbbdbf;
            margin-top: -120px;
            // margin-left: 20px;
            margin: 0;
            width: 100%;
            // border: 1px solid red;
          }
        }
      }

      // 上传照片组件-已选择文件
      :deep(.hiddenUpload .el-upload.el-upload--picture-card) {
        display: none !important;
      }
      :deep(.el-upload-list__item.is-ready) {
        width: 160px;
        height: 160px;
        // border:1px solid red;
      }

      // 上传照片组件-未选择文件
      :deep(.el-upload.el-upload--picture-card) {
        flex-direction: column;
        width: 200px;
        height: 160px;
        background-color: #f5f6f9;
        border-color: #d9d9d9;
        // border:1px solid red;
        > i {
          font-size: 24px;
          color: #009de0;
        }
        .upload-tip {
          margin-top: 10px;
          color: #333333;
          font-size: 14px;
        }
      }
      :deep(.el-form-item__content > div > ul) {
        width: 100% !important;
        > .el-upload.el-upload--picture-card {
          width: 160px;
          height: 160px;
        }
      }
    }

    ///////已读勾选 与 提交按钮
    .last-box {
      width: 343px;
      // border: 1px solid red;
      margin: 0 auto;
      margin-top:40px;
      align-items: center;
      ////// 按钮
      :deep(.el-button.el-button--primary) {
        width: 343px;
        height: 40px;
        border-radius: 8px;
        // margin-left: 111px;
        > span {
          font-size: 14px;
          font-weight: 400;
        }
      }

      /////已读勾选框
      :deep(.login-checkbox) {
        margin-top: 12px;
        margin-left: 111px;
        // border:1px solid red;
        height: 20px;
        .text {
          span {
            color: #009de0;
          }
        }
      }
    }
  }
}
.my-radio {
  :deep(.el-form-item__label) {
    // margin-top: 5px;
    // border:1px solid red;
  }
}
</style>
